const all_base_urls = {
    "demo": "https://live.api.nymbleup.com/api/v1",
    "cprl": "https://cprl.api.nymbleup.com/api/v1",
    "hardcastleindia": "https://hardcastleindia.api.nymbleup.com/api/v1",
    "bluetokai": "https://bluetokai.api.nymbleup.com/api/v1",
    "mystarbucks": "https://mystarbucks.api.nymbleup.com/api/v1",
    "dil-kfc": "https://dil-kfc.api.nymbleup.com/api/v1",
    "location": "https://location.api.nymbleup.com/api/v1",
};

export const getBaseUrl = () => {
    // Get the current window URL
    let result = 'demo';
    const url = window.location.href;
    // Check if the URL is localhost
    if (url.includes("localhost") || url.includes("web.app")) {
        result = localStorage.getItem('BASE_URL') || process.env.VUE_APP_BASE_URL;
    } else {
        // Use a regular expression to extract the subdomain
        const subdomainMatch = url.match(/^(?:https?:\/\/)?([^\/]+)\./);
        const subdomain = subdomainMatch ? subdomainMatch[1] : "demo";
        if(all_base_urls[subdomain.split('.')[0]]) {
            result = all_base_urls[subdomain.split('.')[0]];
        } else {
            result = process.env.VUE_APP_BASE_URL || localStorage.getItem('BASE_URL');
        }
    }
    return result;
}

export const base_url_list = [
    {
        label: "Demo",
        value: "https://live.api.nymbleup.com/api/v1"
    },
    {
        label: "CPRL",
        value: "https://cprl.api.nymbleup.com/api/v1"
    },
    {
        label: "Hardcastle India",
        value: "https://hardcastleindia.api.nymbleup.com/api/v1"
    },
    {
        label: "Bluetokai",
        value: "https://bluetokai.api.nymbleup.com/api/v1"
    },
    {
        label: "Starbucks Malaysia",
        value: "https://mystarbucks.api.nymbleup.com/api/v1"
    },
    {
        label: "DIL-KFC",
        value: "https://dil-kfc.api.nymbleup.com/api/v1"
    },
    {
        label: "Location",
        value: "https://location.api.nymbleup.com/api/v1"
    },
    {
        label: "Burger King",
        value: "https://location.api.nymbleup.com/api/v1"
    },
]